import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { SEO } from "@/components/SEO";
import { Nav, Footer, WhatsAppButton, StickyMobileCTA } from "@/components/Chrome";
import { MARQUEE_ITEMS } from "@/data/content";
import Opening from "@/sections/Opening";
import Hero from "@/sections/Hero";
import Problem from "@/sections/Problem";
import LaunchFilm from "@/sections/LaunchFilm";
import SystemMap from "@/sections/SystemMap";
import DigitalTeam from "@/sections/DigitalTeam";
import DemoCentre from "@/sections/DemoCentre";
import Simulator from "@/sections/Simulator";
import Stats from "@/sections/Stats";
import Services from "@/sections/Services";
import Reviews from "@/sections/Reviews";
import About from "@/sections/About";
import Consult from "@/sections/Consult";
import FinalCTA from "@/sections/FinalCTA";

function Marquee() {
    const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div className="overflow-hidden border-y border-white/10 bg-void py-6" aria-hidden="true" data-testid="editorial-marquee">
            <div className="animate-hights-marquee flex w-max items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="px-8 font-display text-2xl font-black tracking-[0.3em] text-white/25">{item}</span>
                                <span className="h-1.5 w-1.5 bg-white/20" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function HomePage() {
    const [entered, setEntered] = useState(false);

    return (
        <div className="min-h-screen bg-base" data-testid="home-page">
            <SEO
                title="HIGHTS — Your Business. Engineered to Grow. | AI Business Automation & Websites"
                description="HIGHTS builds connected growth systems: premium bespoke websites, AI enquiry agents, AI receptionists, CRM automation, SEO and business automation for businesses of any size."
                path="/"
            />
            <AnimatePresence>
                {!entered && <Opening key="opening" onEnter={() => setEntered(true)} />}
            </AnimatePresence>
            <Nav />
            <main>
                <Hero entered={entered} />
                <Marquee />
                <Problem />
                <LaunchFilm />
                <SystemMap />
                <DigitalTeam />
                <DemoCentre />
                <Simulator />
                <Stats />
                <Services />
                <Reviews />
                <About />
                <Consult />
                <FinalCTA />
            </main>
            <Footer />
            <WhatsAppButton />
            <StickyMobileCTA />
        </div>
    );
}
